<template>
  <div style="padding: 1vw">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 0 1vw;
      "
    >
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          병원 관리 (등록 병원 수: {{ addCommaToNumber(listSize) }})
        </h3>
        <span class="pageDesc">
          우리 서비스를 사용하는 병원을 등록하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center">
        <a
          v-if="emrTunnelDownloadUrl"
          :href="emrTunnelDownloadUrl"
          class="btn btn-primary"
          style="margin-right: 10px"
          download
        >
          <i class="fa-solid fa-download" />
          EMR Tunnel 다운로드
        </a>
        <button
          type="button"
          class="btn btn-primary"
          @click="uploadBulkFile"
          style="margin-right: 10px"
        >
          <i class="fa-regular fa-plus" />
          병원 대량 등록
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="downloadBulkExample"
          style="margin-right: 10px"
        >
          <i class="fa-solid fa-down-to-bracket" />
          병원 대량 등록 양식 다운로드(.xlsx)
        </button>
        <input
          type="file"
          ref="bulkFileInput"
          style="width: 0; height: 0; display: none"
        />
        <button
          class="btn btn-primary"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#hospitalInfoWModal"
        >
          등록하기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox">
        <select id="itemCode" v-model="selectedDept" @change="enter()">
          <option value="" selected>진료과목</option>
          <option v-for="item in deptList" :value="item.code" :key="item">
            {{ `${item.name}` }}
          </option>
        </select>
        <select
          v-model="selectedAreaFirst"
          id="itemCode"
          @change="areaSecondChange()"
        >
          <option value="" selected>시/도 선택</option>
          <option v-for="item in areaFirst" :value="item" :key="item">
            {{ `${item}` }}
          </option>
        </select>
        <select
          v-model="selectedAreaSecond"
          id="itemCode"
          @change="areaThirdChange()"
        >
          <option value="" selected>시/군/구 선택</option>
          <option v-for="item in areaSecond" :value="item" :key="item">
            {{ `${item}` }}
          </option>
        </select>
        <select
          v-model="selectedAreaThird"
          id="itemCode"
          @change="areaLastChange()"
        >
          <option value="" selected>읍/면/동 선택</option>
          <option v-for="item in areaThird" :value="item" :key="item">
            {{ `${item}` }}
          </option>
        </select>
        <select v-model="deleteFilter" id="itemCode" @change="enter()">
          <option value="" selected>전체</option>
          <option value="N">삭제 안된 병원만</option>
          <option value="Y">삭제된 병원만</option>
        </select>
        <select
          v-model="registrationStatusFilter"
          id="itemCode"
          @change="enter()"
        >
          <option value="" selected>등록상태 전체</option>
          <option value="ACTIVE">활성</option>
          <option value="PENDING">승인대기</option>
          <option value="REJECTED">거절됨</option>
        </select>
        <button @click="initFilter()">옵션 초기화</button>
      </div>
      <div class="searchinputbox">
        <select v-model="searchFilter" id="itemCode">
          <option value="" selected>선택</option>
          <option value="name">병원명</option>
          <option value="cNo">사업자등록번호</option>
          <option value="adminName">관리자명</option>
          <option value="uesrname">관리자 ID</option>
        </select>
        <input
          type="text"
          placeholder="조건을 입력해주세요."
          v-model="condition"
          ref="cdInput"
          id=""
          autocomplete="off"
          :readonly="!isFocused"
          @focus="isFocused = true"
          @keyup.enter="enter()"
        />
        <div class="searchBtn">
          <img
            src="../../assets/img/search.png"
            alt="search"
            class="hoverPointer"
            @click="enter()"
          />
        </div>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div />
      <div class="searchinputbox">
        <select
          class="search-select"
          v-model="rowsPerPage"
          @change="handleRowsPerPage"
        >
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
        </select>
      </div>
    </div>

    <div class="container-wrapper">
      <a-table
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
        @change="handleTableChange"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination
        :page-info="paginationData"
        page-name="CustomerManage"
        @change-page="paginationHandler"
      />
    </div>
    <!-- 초기화 모달 -->
    <div
      class="modal fade"
      id="resetyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>비밀번호 초기화</h4>
              <h6>임시 비밀번호는 사용자 아이디와 동일합니다.</h6>
              <h6>초기화하시겠습니까?</h6>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 2rem"
            >
              <button
                style="margin-right: 1vw"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                @click="resetPassword()"
              >
                초기화
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 삭제 모달 -->
    <div
      class="modal fade"
      id="deleteyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>병원 삭제</h4>
              <h6>해당 병원을 삭제하시겠습니까?</h6>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 2rem"
            >
              <button
                style="margin-right: 1vw"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                @click="deleteHospital()"
              >
                삭제
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <HospitalInfoW />
  <HospitalInfoM :data="hospitalDetailData" />
  <EmrTokenModal
    v-model:visible="emrTokenModalVisible"
    :company-id="emrTokenCompanyId"
    :is-reissue="emrTokenIsReissue"
    @success="handleEmrTokenSuccess"
  />
  <EmrBlockedIpModal
    v-model:visible="emrBlockedIpModalVisible"
    :company-id="emrBlockedIpCompanyId"
    :hospital-name="emrBlockedIpHospitalName"
    :hospital-c-no="emrBlockedIpHospitalCNo"
  />
  <RejectReasonModal
    :visible="rejectModalVisible"
    :company="selectedCompanyForReject"
    :loading="rejectLoading"
    @cancel="closeRejectModal"
    @submit="handleReject"
  />
  <!-- 목록 행 「지원 접속」 창(10-29) -->
  <support-entry-dialog
    v-model:open="supportOpen"
    :company-id="supportTarget.id"
    :company-type="supportTarget.type"
    :company-name="supportTarget.name"
  />
</template>
<script>
import supportEntryMixin from "@/mixins/supportEntryMixin";
import {
  openDialog,
  oneBtnDialog,
  businessNumberFormatter,
  phoneNumberFormatter,
  addCommaToNumber,
  convertDateTime,
  changeBytesToKilos,
} from "../../utils/utils";
import jsonFile from "../../assets/locations.json";
import HospitalInfoW from "../components/HospitalInfoW.vue";
import HospitalInfoM from "../components/HospitalInfoM.vue";
import Pagination from "@/views/components/Pagination.vue";
import EmrTokenModal from "../components/EmrTokenModal.vue";
import EmrBlockedIpModal from "../components/EmrBlockedIpModal.vue";
import RejectReasonModal from "../components/RejectReasonModal.vue";
import Swal from "sweetalert2";
import { MedicalDept } from "@/utils/enums";
import { YnEnum } from "@/enums/common.enums";

export default {
  mixins: [supportEntryMixin],
  name: "hosManage",
  components: {
    HospitalInfoW,
    HospitalInfoM,
    Pagination,
    EmrTokenModal,
    EmrBlockedIpModal,
    RejectReasonModal,
  },
  data() {
    return {
      addCommaToNumber,
      type: "HOSPITAL",
      emrTunnelDownloadUrl: process.env.VUE_APP_EMR_TUNNEL_DOWNLOAD_URL || "",
      // 목록 받아오는 변수
      responseData: [],

      selectedHospital: "", // 선택한 병원 id
      selectedManager: "", // 선택한 관리자 id
      hospitalDetailData: {}, // 자동완성 때문에 최초엔 폴스로
      selectedAccountInfo: {},
      isFocused: false, // 자동완성 때문에 최초엔 폴스로

      // 필터용 데이터
      deptList: [], //과목 목록
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: "", // 선택된 시군구 대분류
      selectedAreaSecond: "", // 선택된 시군구 중분류
      selectedAreaThird: "", // 선택된 읍면동 소분류
      selectedDept: "", // 선택된 과
      deleteFilter: "", // 삭제 여부
      registrationStatusFilter: "", // 등록 상태 필터
      reapproving: {}, // 재승인 로딩 상태
      rejectModalVisible: false, // 거절 모달
      rejectLoading: false, // 거절 로딩 상태
      selectedCompanyForReject: null, // 거절할 회사 정보
      searchFilter: "", // 필터 종류
      previousCondition: "", // 검색어
      condition: "", // 검색어
      sortOrder: null, // 정렬 기준
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      paginationData: {
        currentPage: 1,
        totalPages: 0,
      },
      // EMR Token 모달 관련
      emrTokenModalVisible: false,
      emrTokenCompanyId: "",
      emrTokenIsReissue: false,
      // EMR 차단 IP 모달 관련
      emrBlockedIpModalVisible: false,
      emrBlockedIpCompanyId: "",
      emrBlockedIpHospitalName: "",
      emrBlockedIpHospitalCNo: "",
      columns: [
        { key: "index", title: "번호", dataIndex: "index", align: "center" },
        {
          key: "medicalDept",
          title: "진료과목",
          dataIndex: "medicalDept",
          align: "center",

          customRender: ({ record }) => {
            const medicalDept = record.medicalDept.filter(
              (item) => item !== MedicalDept.COMMON
            );
            return this.convertDeptsToString(medicalDept);
          },
        },
        { key: "name", title: "병원명", dataIndex: "name", align: "center" },
        {
          key: "cNo",
          title: "사업자등록번호",
          dataIndex: "birth",
          align: "center",
          customRender: ({ record }) => {
            return this.businessNumberFormatter(record.cNo);
          },
        },
        {
          key: "formattedAddress",
          title: "지역",
          dataIndex: "formattedAddress",
          align: "center",
        },
        {
          key: "warrantyCount",
          title: "발행 인증서 수",
          dataIndex: "warrantyCount",
          align: "center",
          sorter: true,
          sortDirections: ["ascend", "descend"],
          showSorterTooltip: false,
        },
        {
          key: "manufacturerNames",
          title: "등록 제조사",
          dataIndex: "manufacturerNames",
          align: "center",
          customRender: ({ record }) => {
            let index = 0;
            return record.manufacturerNames.map((i) => {
              let returnValue =
                record.manufacturerNames.length - 1 == index ? i : i + ",";
              index++;
              return returnValue;
            });
          },
        },
        {
          key: "createAt",
          title: "병원 생성 일시",
          dataIndex: "createAt",
          align: "center",
          customRender: ({ record }) => {
            return this.convertDateTime(record.createAt);
          },
        },
        {
          key: "registrationStatus",
          title: "등록상태",
          dataIndex: "registrationStatus",
          align: "center",
          width: 100,
          customRender: ({ record }) => {
            const status = record.registrationStatus;
            if (status === "REJECTED") {
              return (
                <a-tooltip title={record.rejectionReason || "거절 사유 없음"}>
                  <a-tag color="red">거절됨</a-tag>
                </a-tooltip>
              );
            } else if (status === "PENDING") {
              return <a-tag color="orange">승인대기</a-tag>;
            } else {
              return <a-tag color="green">활성</a-tag>;
            }
          },
        },
        {
          key: "isTestCompany",
          title: "테스트 병원 여부",
          dataIndex: "isTestCompany",
          align: "center",
          customRender: ({ record }) => {
            return record.isTestCompany === YnEnum.Y ? "예" : "아니오";
          },
        },
        {
          key: "accountInfo_name",
          title: "관리자명",
          dataIndex: "accountInfo_name",
          align: "center",
        },
        {
          key: "accountInfo_mobile",
          title: "연락처",
          dataIndex: "accountInfo_mobile",
          align: "center",
        },
        {
          key: "accountInfo_username",
          title: "관리자 아이디",
          dataIndex: "accountInfo_username",
          align: "center",
        },
        {
          key: "emrTunnel",
          title: "EMR Tunnel",
          dataIndex: "emrTunnel",
          align: "center",
          width: 260,
          customRender: ({ record }) => {
            if (record.deleteYn === "N") {
              return (
                <div style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                  <div
                    type="button"
                    class="certi-custom-btn"
                    onClick={() => {
                      this.openEmrTokenModal(record);
                    }}
                  >
                    {record.hasEmrToken ? "Token 재발급" : "Token 발급"}
                  </div>
                  {record.hasEmrToken && (
                    <div
                      type="button"
                      class="certi-custom-btn certi-custom-btn-danger"
                      onClick={() => {
                        this.confirmDisconnectEmrSession(record);
                      }}
                    >
                      소켓 연결 해지
                    </div>
                  )}
                  {record.hasEmrToken && (
                    <div
                      type="button"
                      class="certi-custom-btn"
                      onClick={() => {
                        this.openEmrBlockedIpModal(record);
                      }}
                    >
                      차단 IP 관리
                    </div>
                  )}
                </div>
              );
            } else {
              return <div style="color: #999;">-</div>;
            }
          },
        },
        {
          key: "manage",
          title: "관리",
          dataIndex: "manage",
          align: "center",
          customRender: ({ record }) => {
            if (record.deleteYn === "N") {
              return (
                <div style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                  {record.registrationStatus === "PENDING" && (
                    <div
                      type="button"
                      class="certi-custom-btn certi-custom-btn-success"
                      onClick={() => {
                        this.handleApprove(record);
                      }}
                    >
                      {this.reapproving[record._id] ? "처리중..." : "승인"}
                    </div>
                  )}
                  {record.registrationStatus === "PENDING" && (
                    <div
                      type="button"
                      class="certi-custom-btn certi-custom-btn-danger"
                      onClick={() => {
                        this.openRejectModal(record);
                      }}
                    >
                      거절
                    </div>
                  )}
                  {record.registrationStatus === "REJECTED" && (
                    <div
                      type="button"
                      class="certi-custom-btn certi-custom-btn-success"
                      onClick={() => {
                        this.handleApprove(record);
                      }}
                    >
                      {this.reapproving[record._id] ? "처리중..." : "승인"}
                    </div>
                  )}
                  {this.canSupportEntry && (
                    <div
                      type="button"
                      class="certi-custom-btn"
                      onClick={() => {
                        this.openSupport(record, "HOSPITAL");
                      }}
                    >
                      지원 접속
                    </div>
                  )}
                  <div
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#hospitalInfoMModal"
                    class="certi-custom-btn"
                    onClick={() => {
                      this.getHospitalDetail(record._id);
                    }}
                  >
                    수정
                  </div>
                  <div
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteyesno"
                    class="certi-custom-btn"
                    onClick={() => {
                      this.selectHospital(record);
                    }}
                  >
                    삭제
                  </div>
                  <div
                    type="button"
                    class="certi-custom-btn"
                    onClick={() => {
                      this.goToOrderPage(record);
                    }}
                  >
                    주문조회
                  </div>
                </div>
              );
            } else {
              return <div style="color: red !important;">삭제됨</div>;
            }
          },
        },
      ],
    };
  },

  async mounted() {
    this.isFocused = false;
    this.getAreaList();
    await this.getDeptList();
    const obj = {};
    obj.page = this.paginationData.currentPage;
    await this.paginationHandler(obj);
  },
  methods: {
    clickFileInput() {
      if (this.$refs.bulkFileInput) this.$refs.bulkFileInput.click();
    },
    async uploadExcelOnObjectStorage(fileData) {
      try {
        const response = await this.$apiInstance.post(
          `/object-storages/excel`,
          fileData
        );
        if (response.status === 200 || response.status === 201) {
          return response.data.url;
        } else {
          return "";
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(
          "엑셀 파일 업로드 실패",
          "엑셀 파일 업로드에 실패하였습니다.",
          false
        );
        return "";
      }
    },

    validateFile(file) {
      let result = true;
      if (file) {
        if (!file.name.endsWith(".xlsx")) {
          alert("xlsx형식 파일만 첨부 가능합니다.");
          result = false;
        } else if (changeBytesToKilos(file.size) > 100) {
          alert("파일 크기가 100MB를 초과합니다.");
          result = false;
        }
      }
      return result;
    },
    async uploadBulkFile() {
      try {
        this.clickFileInput();

        const file = await new Promise((resolve) => {
          this.$refs.bulkFileInput.onchange = (event) => {
            resolve(event.target.files[0]);
          };
        });

        const isValid = this.validateFile(file);
        if (!isValid) return;

        const formData = new FormData();
        formData.append("file", file);

        const objectStorageUrl = await this.uploadExcelOnObjectStorage(
          formData
        );

        if (objectStorageUrl) {
          const obj = {};
          obj.url = objectStorageUrl;
          const response = await this.$apiInstance.post(
            `/companies/import/excel/datas`,
            obj
          );
          if (response.status === 200 || response.status === 201) {
            await Swal.fire({
              title: "병원 대량등록 성공",
              html: `<div>병원 대량등록에 성공하였습니다.</div>
                  <div>전체:${response.data.allCompanyCount}건</div>
                  <div>신규 등록:${response.data.addCompanyCount}건</div>
                  <div>기등록:${response.data.updateCompanyCount}건</div>
                  <div>등록 실패:${response.data.failCompanyCount}건${
                response.data.failCompanyList.length != 0
                  ? `(${response.data.failCompanyList})`
                  : ""
              }</div>
                  `,
              buttonsStyling: false,
              confirmButtonText: "확인",
              heightAuto: true,
              customClass: {
                container: "upload-bulk",
                confirmButton: "btn btn-primary",
              },
            }).then(() => {
              location.reload();
            });
          }
        }
      } catch (error) {
        console.error("Error uploading the file:", error);
        if (error.response && error.response.status === 400) {
          await oneBtnDialog(
            "존재하지 않는 병원",
            "존재하지 않는 병원입니다.",
            false
          );
        } else {
          await oneBtnDialog(
            "병원 대량등록 실패",
            "병원 대량등록에 실패하였습니다.",
            false
          );
        }
      }
    },
    async downloadBulkExample() {
      const year = new Date().getFullYear();
      const month = String(new Date().getMonth() + 1).padStart(2, "0");
      const day = String(new Date().getDate()).padStart(2, "0");

      const formattedDate = `${year}${month}${day}`;
      try {
        const response = await this.$apiInstance.get(
          `/companies/export/excel/form`,
          { responseType: "blob" }
        );

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = `병원대량등록양식_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
        } else {
          // Handle the error case
        }
      } catch (error) {
        console.error(error);
        await oneBtnDialog(
          "파일 다운로드 실패",
          "파일 다운로드에 실패하였습니다.",
          false
        );
      }
    },
    businessNumberFormatter,
    phoneNumberFormatter,
    convertDateTime,
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getHospitalList();
    },

    handleResizeColumn(w, col) {
      col.width = w;
    },
    // 주요 API

    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(
            (item) => item.code !== MedicalDept.COMMON
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 병원 목록 전체
    async getHospitalList() {
      const obj = {};
      if (this.previousCondition !== this.condition) {
        obj.page = 1;
      } else {
        obj.page = this.paginationData.currentPage;
      }
      obj.limit = this.rowsPerPage; // 페이지네이션 관련 변수
      obj.type = this.type;
      if (this.selectedDept) obj.medicalDept = [this.selectedDept];
      if (this.selectedAreaFirst) obj.addrOne = this.selectedAreaFirst;
      if (this.selectedAreaSecond) obj.addrTwo = this.selectedAreaSecond;
      if (this.selectedAreaThird) obj.addrThree = this.selectedAreaThird;
      if (this.deleteFilter) obj.deleteYn = this.deleteFilter;
      if (this.registrationStatusFilter)
        obj.registrationStatus = this.registrationStatusFilter;
      if (this.searchFilter) obj.search = this.searchFilter;
      if (this.condition) obj.condition = this.condition;
      if (this.sortOrder) {
        obj.warrantySortOrder = this.sortOrder;
      }

      try {
        const response = await this.$apiInstance.post(
          `/companies/list/v2`,
          obj
        );
        if (response.status === 200 || response.status === 201) {
          if (this.previousCondition !== this.condition) {
            this.paginationData.currentPage = 1;
          }
          this.previousCondition = this.condition;

          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;

          for (let i = 0; i < this.responseData.length; i++) {
            const item = this.responseData[i];
            item.index =
              this.listSize -
              i -
              (this.paginationData.currentPage - 1) * this.rowsPerPage;
            if (item.addrOne && item.addrTwo && item.addrThree) {
              item.formattedAddress = this.formatAddress(this.responseData[i]);
            }
          }
          this.paginationData.totalPages = response.data.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    formatAddress(input) {
      const firstText = input.addrOne ? input.addrOne : "";
      const secondText = input.addrTwo ? input.addrTwo : "";
      const thirdText = input.addrThree ? input.addrThree : "";
      const combinedText = `${firstText} ${secondText} ${thirdText}`;
      if (combinedText.trim().length === 0) return "-";
      return combinedText;
    },
    // 병원 정보 상세
    async getHospitalDetail(id) {
      try {
        const response = await this.$apiInstance.get(`/companies/${id}`);
        if (response.status === 200 || response.status === 201) {
          this.hospitalDetailData = response.data;
          this.hospitalDetailData.isTestCompany =
            response.data.isTestCompany === YnEnum.Y;
          this.hospitalDetailData.hospitalId = id;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getHospitalList();
    },

    // 비밀번호 초기화
    async resetPassword() {
      try {
        const response = await this.$apiInstance.put(
          `/companies/resetPassword/${this.selectedManager}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "비밀번호가 초기화되었습니다.",
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        } else {
          await openDialog(
            "비밀번호 초기화에 실패하였습니다.",
            "error",
            "확인"
          );
        }
      } catch (error) {
        await openDialog("비밀번호 초기화에 실패하였습니다.", "error", "확인");
        console.log(error);
      }
    },

    // 병원 정보 삭제
    async deleteHospital() {
      try {
        const response = await this.$apiInstance.delete(
          `/companies/${this.selectedHospital}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "해당 병원 정보가 삭제되었습니다.",
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        } else {
          await openDialog("병원 정보 삭제에 실패하였습니다.", "error", "확인");
        }
      } catch (error) {
        console.log(error);
        await openDialog("병원 정보 삭제에 실패하였습니다.", "error", "확인");
      }
    },

    // 기타 hosManage용 utils

    // 엔터 눌렀을 때 실행
    async enter() {
      this.paginationData.currentPage = 1;
      this.getHospitalList();
    },

    // 지역 목록 가져오기
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) =>
        a.localeCompare(b, "ko-KR")
      );
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if (this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = Object.keys(secondLevelData).sort((a, b) =>
          a.localeCompare(b, "ko-KR")
        );
        this.areaThird = [];
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
      this.paginationData.currentPage = 1;
      this.getHospitalList();
    },

    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
        this.areaThird = Object.keys(thirdLevelData).sort((a, b) =>
          a.localeCompare(b, "ko-KR")
        );
        this.selectedAreaThird = "";
      } else {
        this.selectedAreaThird = "";
        this.areaThird = [];
      }
      this.paginationData.currentPage = 1;
      this.getHospitalList();
    },
    async areaLastChange() {
      this.paginationData.currentPage = 1;
      this.getHospitalList();
    },
    // 필터 초기화
    initFilter() {
      this.paginationData.currentPage = 1;
      this.selectedDept = "";
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
      this.deleteFilter = "";
      this.registrationStatusFilter = "";
      this.searchFilter = "";
      this.condition = "";
      this.getHospitalList();
    },

    // 승인 처리
    async handleApprove(record) {
      this.reapproving[record._id] = true;
      try {
        const response = await this.$apiInstance.patch(
          `/companies/signup/approve/${record._id}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            `${record.name}의 가입이 승인되었습니다.`,
            "success",
            "확인"
          );
          await this.getHospitalList();
        }
      } catch (error) {
        console.error("승인 실패:", error);
        await openDialog(
          error.response?.data?.message || "승인 처리에 실패했습니다.",
          "error",
          "확인"
        );
      } finally {
        this.reapproving[record._id] = false;
      }
    },

    // 거절 모달 열기
    openRejectModal(record) {
      this.selectedCompanyForReject = record;
      this.rejectModalVisible = true;
    },

    // 거절 모달 닫기
    closeRejectModal() {
      this.rejectModalVisible = false;
      this.selectedCompanyForReject = null;
    },

    // 거절 처리
    async handleReject(reason) {
      if (!this.selectedCompanyForReject) return;

      this.rejectLoading = true;
      try {
        const response = await this.$apiInstance.patch(
          `/companies/signup/reject/${this.selectedCompanyForReject._id}`,
          { reason }
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            `${this.selectedCompanyForReject.name}의 가입이 거절되었습니다.`,
            "success",
            "확인"
          );
          this.closeRejectModal();
          await this.getHospitalList();
        }
      } catch (error) {
        console.error("거절 실패:", error);
        await openDialog(
          error.response?.data?.message || "거절 처리에 실패했습니다.",
          "error",
          "확인"
        );
      } finally {
        this.rejectLoading = false;
      }
    },

    // 보기, 수정, 삭제 시 선택
    selectHospital(hospital) {
      this.selectedHospital = hospital._id;
      this.selectedManager = hospital.accountInfo_id;
    },

    // 과목 코드를 이름으로 변환
    convertDeptToText(code) {
      const department = this.deptList.find((item) => item.code === code);
      return department ? department.name : "-";
    },

    // 과목명 가공
    convertDeptsToString(array) {
      let deptString = "";
      if (array && array.length > 0) {
        for (const dept of array) {
          deptString += `${this.convertDeptToText(dept)} / `;
        }
        return deptString.slice(0, -2);
      } else {
        return "-";
      }
    },

    goToOrderPage(hospital) {
      this.$router.push({
        path: "/orders/management",
        query: {
          hospitalName: hospital.name,
        },
      });
    },

    handleTableChange(pagination, filters, sorter) {
      if (sorter.order) {
        this.sortOrder = sorter.order;
      } else {
        this.sortOrder = null;
      }
      this.getHospitalList();
    },

    // EMR Token 모달 열기
    openEmrTokenModal(record) {
      this.emrTokenCompanyId = record._id;
      this.emrTokenIsReissue = record.hasEmrToken === true;
      this.emrTokenModalVisible = true;
    },

    // EMR Token 발급 성공 후 목록 새로고침
    handleEmrTokenSuccess() {
      this.getHospitalList();
    },

    // EMR 세션 강제 종료 확인
    async confirmDisconnectEmrSession(record) {
      const result = await Swal.fire({
        title: "소켓 연결 해지",
        html: `<div>강제로 <strong>${record.name}</strong>과 연관된 소켓이 모두 연결 해지됩니다.</div>
               <div style="margin-top: 8px;">정말로 해지하시겠습니까?</div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "연결 해지",
        cancelButtonText: "취소",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
      });

      if (result.isConfirmed) {
        await this.disconnectEmrSession(record._id);
      }
    },

    // EMR 세션 강제 종료 API 호출
    async disconnectEmrSession(companyId) {
      try {
        const response = await this.$apiInstance.delete(
          `/companies/emr-tunnel/${companyId}/session`,
          { data: { reason: "관리자 요청에 의한 연결 종료" } }
        );

        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "소켓 연결 해지 요청이 전송되었습니다.",
            "success",
            "확인"
          );
        }
      } catch (error) {
        console.error("EMR 세션 종료 실패:", error);
        if (error.response?.status === 404) {
          await openDialog("병원을 찾을 수 없습니다.", "error", "확인");
        } else if (error.response?.status === 403) {
          await openDialog("권한이 없습니다.", "error", "확인");
        } else {
          await openDialog("소켓 연결 해지에 실패했습니다.", "error", "확인");
        }
      }
    },

    // EMR 차단 IP 모달 열기
    openEmrBlockedIpModal(record) {
      this.emrBlockedIpCompanyId = record._id;
      this.emrBlockedIpHospitalName = record.name;
      this.emrBlockedIpHospitalCNo = this.businessNumberFormatter(record.cNo);
      this.emrBlockedIpModalVisible = true;
    },
  },
};
</script>
